var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.3333 8.33333L20.9833 10.6833L23.6167 13.3333H10V16.6667H23.6167L20.9833 19.3L23.3333 21.6667L30 15L23.3333 8.33333ZM3.33333 3.33333H15V0H3.33333C1.5 0 0 1.5 0 3.33333V26.6667C0 28.5 1.5 30 3.33333 30H15V26.6667H3.33333V3.33333Z",
    fill: "var(--fill-0, #F3F4F6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminLogout);
export default __webpack_public_path__ + "static/media/AdminLogout.eb549f505a0221a9a1c760ed907dba95.svg";
export { ForwardRef as ReactComponent };